export const routes = {
    DEFAULT: '/',
    LOGIN: 'login',
    AUTH_CALLBACK: 'auth/callback',
    ERROR: 'error',
    TRANSPORT_ORDERS: 'transport-orders',
    IN_TRANSIT: 'in-transit',
    DELIVERED: 'delivered',
    ARCHIVED: 'archived',
} as const;
